import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=516256a8&scoped=true"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=516256a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516256a8",
  null
  
)

export default component.exports